import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyBr6_L6DrVQFSglWl8QnMoDHFtma1cEaUw",
    authDomain: "devsensor-c7daf.firebaseapp.com",
    projectId: "devsensor-c7daf",
    storageBucket: "devsensor-c7daf.appspot.com",
    messagingSenderId: "738419127347",
    appId: "1:738419127347:web:2d0dd14a09c11a1e2e9f46",
    measurementId: "G-5EJV94BX0W"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const getOrRegisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    return window.navigator.serviceWorker
      .getRegistration('/firebase-push-notification-scope')
      .then((serviceWorker) => {
        if (serviceWorker) return serviceWorker;
        return window.navigator.serviceWorker.register('/firebase-messaging-sw.js', {
          scope: '/firebase-push-notification-scope',
        });
      });
  }
  alert('The browser doesn`t support service worker.');
  throw new Error('The browser doesn`t support service worker.');
};

export const getFirebaseToken = () =>
  getOrRegisterServiceWorker()
    .then((serviceWorkerRegistration) => {
      console.log({ serviceWorkerRegistration });
      return getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY, serviceWorkerRegistration
      })
});

export const onForegroundMessage = () =>
  new Promise((resolve) => onMessage(messaging, (payload) => resolve(payload)));